// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"bf578282","519":"38945e05"}[chunkId] + ".chunk.css";
};